module.exports = __webpack_public_path__ + "media/music/piano_0-ad734cf1.mp3";